import { InjectionToken } from '@angular/core';

// Define the environment configuration interface
export interface EnvironmentConfig {
    production: boolean;
    coreAppUrl: string;
    adminAppUrl: string;
    apiUrl: string;
    authApiUrl: string;
    blogApiUrl: string;
    enableDebug: boolean;
    version: string;
    appName: string;
    features: {
        enableAnalytics: boolean;
        enableLogging: boolean;
    };
    googleAnalyticsId?: string;
    apiResource?: string;
    appTitleSuffix: string;
    productionOnly?: boolean;
}

// Create an injection token for the environment
export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('environment.config');

declare global {
    interface Window {
        APP_NAME: string;
    }
}
